module.exports = __webpack_public_path__ + "static/media/android_icon_white.262d0b96.svg";